import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="uebertrage-datum"
export default class extends Controller {
	static targets = ["zieldatumSelect"]

	connect() {}

	// Uebertraegt den Monat auf alle ZielTargets
	uebertrage_monat({ currentTarget }) {
		this.zieldatumSelectTargets.forEach((zieldatumSelect) => {
			// Value in Selectbox setzen
			zieldatumSelect.value = currentTarget.value
			// Label in Selectbox setzen (Trigger Change)
			zieldatumSelect.dispatchEvent(new Event("change"))
		})
	}
}
